import { render, staticRenderFns } from "./PurchaseRequestDetailInput.vue?vue&type=template&id=54a273f0&scoped=true&"
import script from "./PurchaseRequestDetailInput.vue?vue&type=script&lang=js&"
export * from "./PurchaseRequestDetailInput.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseRequestDetailInput.vue?vue&type=style&index=0&id=54a273f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a273f0",
  null
  
)

export default component.exports